export const CLUE_MAX_LENGTH = 47;
